import {createMemoryHistory} from 'history';
import { browserHistory, hashHistory } from 'react-router';

let types = {
    hash : ()=>hashHistory,
    browser : ()=>browserHistory,
    memory : ()=>createMemoryHistory()
}

export const DEFAULT_HISTORY_TYPE='browser';

export function getHistory(type=DEFAULT_HISTORY_TYPE){
    return types[type]();
}


// WEBPACK FOOTER //
// ./src/helpers/history.js